var _stop, _stop2, _stop3, _stop4, _stop5, _stop6, _stop7, _stop8, _stop9, _stop10, _stop11, _stop12, _stop13, _stop14, _stop15, _stop16, _stop17, _stop18, _feOffset, _feGaussianBlur, _feColorMatrix, _feMerge, _feOffset2, _feGaussianBlur2, _feColorMatrix2, _feMerge2, _feOffset3, _feGaussianBlur3, _feColorMatrix3, _feMerge3, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgIconsPopupNotifications(props) {
  var _id12 = useUniqueInlineId();

  var _id11 = useUniqueInlineId();

  var _id10 = useUniqueInlineId();

  var _id9 = useUniqueInlineId();

  var _id8 = useUniqueInlineId();

  var _id7 = useUniqueInlineId();

  var _id6 = useUniqueInlineId();

  var _id5 = useUniqueInlineId();

  var _id4 = useUniqueInlineId();

  var _id3 = useUniqueInlineId();

  var _id2 = useUniqueInlineId();

  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 88,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.013%",
    y1: "7.565%",
    x2: "34.606%",
    y2: "87.141%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.397%",
    y1: "50%",
    x2: "50.248%",
    y2: "-.844%",
    id: _id2
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE",
    offset: "0%"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.274%",
    y1: "-.844%",
    x2: "50.274%",
    y2: "97.755%",
    id: _id3
  }, _stop5 || (_stop5 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD",
    offset: "0%"
  })), _stop6 || (_stop6 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4600DB",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.013%",
    y1: "7.565%",
    x2: "34.606%",
    y2: "87.141%",
    id: _id4
  }, _stop7 || (_stop7 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop8 || (_stop8 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.945%",
    y1: "50%",
    x2: "50.24%",
    y2: "-.844%",
    id: _id5
  }, _stop9 || (_stop9 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE",
    offset: "0%"
  })), _stop10 || (_stop10 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.274%",
    y1: "-.844%",
    x2: "50.274%",
    y2: "97.755%",
    id: _id6
  }, _stop11 || (_stop11 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD",
    offset: "0%"
  })), _stop12 || (_stop12 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4600DB",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.013%",
    y1: "7.565%",
    x2: "34.606%",
    y2: "87.141%",
    id: _id7
  }, _stop13 || (_stop13 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE00C1",
    offset: "0%"
  })), _stop14 || (_stop14 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C27",
    offset: "99.918%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "93.945%",
    y1: "50%",
    x2: "50.24%",
    y2: "-.844%",
    id: _id8
  }, _stop15 || (_stop15 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDF7FE",
    offset: "0%"
  })), _stop16 || (_stop16 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFFF",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.274%",
    y1: "-.844%",
    x2: "50.274%",
    y2: "97.755%",
    id: _id9
  }, _stop17 || (_stop17 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A7FD",
    offset: "0%"
  })), _stop18 || (_stop18 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4600DB",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-111.7%",
    y: "-88.6%",
    width: "323.4%",
    height: "277.2%",
    filterUnits: "objectBoundingBox",
    id: _id10
  }, _feOffset || (_feOffset = /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix || (_feColorMatrix = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  })), _feMerge || (_feMerge = /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("filter", {
    x: "-83.5%",
    y: "-65.2%",
    width: "267.1%",
    height: "230.4%",
    filterUnits: "objectBoundingBox",
    id: _id11
  }, _feOffset2 || (_feOffset2 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur2 || (_feGaussianBlur2 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix2 || (_feColorMatrix2 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  })), _feMerge2 || (_feMerge2 = /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("filter", {
    x: "-99.1%",
    y: "-77.4%",
    width: "298.2%",
    height: "254.7%",
    filterUnits: "objectBoundingBox",
    id: _id12
  }, _feOffset3 || (_feOffset3 = /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  })), _feGaussianBlur3 || (_feGaussianBlur3 = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  })), _feColorMatrix3 || (_feColorMatrix3 = /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  })), _feMerge3 || (_feMerge3 = /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.74 5.604a2.775 2.775 0 013.363 2.02l7.863 31.538a2.775 2.775 0 01-2.021 3.363l-17.692 4.411a2.775 2.775 0 01-3.363-2.02L9.027 13.377a2.775 2.775 0 012.02-3.363zm.654 2.296l-.08.012-17.69 4.41a.396.396 0 00-.29.481l7.864 31.537a.396.396 0 00.48.289l17.692-4.411a.396.396 0 00.288-.48L29.795 8.2a.396.396 0 00-.48-.288zm-.762 28.369a1.19 1.19 0 01-.757 1.408l-.125.037a1.19 1.19 0 01-.685-2.275l.125-.036a1.19 1.19 0 011.442.866z",
    fill: "url(#".concat(_id, ")"),
    fillRule: "nonzero",
    transform: "rotate(34 -17.5 70.24)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id10, ")"),
    transform: "rotate(-18 124.832 -41.71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.63 1.98c2.317 0 4.196 1.971 4.196 4.403 0 2.431-1.877 4.402-4.193 4.404-2.317-.002-4.195-1.972-4.197-4.404h-.002c0-2.432 1.878-4.404 4.196-4.404",
    fill: "url(#".concat(_id2, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.56 0H.498A.518.518 0 00.18.177L.022.32C.008.4.001.481 0 .562c0 .953 1.052 1.049 1.052 1.049.605.145 1.022.71.99 1.34.001.115-.011.23-.036.343a1.36 1.36 0 00-.143.588c0 .75.83 1.006.83 1.006.451.21.738.67.733 1.175 0 .232-.049.462-.141.674-.17.207-.267.465-.277.734 0 .618.642.97.642.97.31.242.495.614.501 1.011-.01.33-.115.649-.304.917a1.096 1.096 0 00-.446.843c.028.348.188.671.446.902.195.237.305.534.312.843-.017.42-.2.815-.506 1.097a1.02 1.02 0 00-.628.919c.012.283.109.557.277.784.099.202.152.424.157.65 0 .786-.75 1.205-.75 1.205-.664.202-.83.632-.83.995.003.207.047.411.127.601.033.132.05.267.05.402 0 .99-1.004 1.29-1.004 1.29C.155 20.96 0 21.583 0 21.977c0 .1.009.2.028.298l.14.13c.094.087.21.145.336.165h11.058c3.491.012 6.33-2.853 6.342-6.398a6.463 6.463 0 00-2.21-4.898c2.641-2.316 2.934-6.368.653-9.05A6.277 6.277 0 0011.565 0h-.005m.381 1.923c2.354 0 4.262 1.937 4.262 4.328 0 2.39-1.906 4.327-4.259 4.328-2.353-.001-4.26-1.938-4.262-4.328H7.68c0-2.39 1.908-4.328 4.261-4.328",
    fill: "url(#".concat(_id3, ")")
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.184 4.575c.773 0 1.4.616 1.4 1.376 0 .76-.627 1.376-1.4 1.376a1.388 1.388 0 01-1.398-1.376c0-.133.019-.263.055-.385a.512.512 0 00.804-.42.503.503 0 00-.172-.379c.207-.122.45-.192.711-.192z",
    fill: "#1D1D1B"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M63.444 3.09a3.5 3.5 0 014.243 2.55l9.919 39.782a3.5 3.5 0 01-2.55 4.243L52.74 55.229a3.5 3.5 0 01-4.243-2.55l-9.919-39.781a3.5 3.5 0 012.55-4.243zm.815 2.898l-.089.014-22.317 5.564a.5.5 0 00-.364.606l9.919 39.782a.5.5 0 00.606.364l22.317-5.564a.5.5 0 00.364-.606L64.776 6.366a.5.5 0 00-.606-.364zm-.95 35.785a1.5 1.5 0 01-.955 1.776l-.158.047a1.5 1.5 0 01-.864-2.87l.158-.046a1.5 1.5 0 011.818 1.093z",
    fill: "url(#".concat(_id4, ")"),
    fillRule: "nonzero",
    transform: "translate(17.408 13.34)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id11, ")"),
    transform: "rotate(1 -727.65 4207.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.778 2.371c2.711 0 4.91 2.345 4.91 5.237 0 2.891-2.197 5.235-4.907 5.237-2.711-.002-4.908-2.345-4.91-5.237h-.003c0-2.892 2.198-5.237 4.91-5.237",
    fill: "url(#".concat(_id5, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.525 0H.583A.604.604 0 00.21.21L.026.382A1.75 1.75 0 000 .668c0 1.134 1.23 1.247 1.23 1.247.709.173 1.196.844 1.16 1.595 0 .137-.014.273-.042.407a1.629 1.629 0 00-.169.699c0 .892.972 1.197.972 1.197.528.25.863.797.858 1.397-.001.276-.057.55-.165.802a1.468 1.468 0 00-.324.872c0 .736.75 1.153.75 1.153.364.288.58.731.587 1.204-.011.392-.135.77-.356 1.09a1.31 1.31 0 00-.521 1.002c.032.414.219.798.52 1.073.229.282.358.636.367 1.003a1.894 1.894 0 01-.593 1.303c-.434.181-.723.61-.735 1.093.014.338.127.663.324.933.116.24.179.504.185.772 0 .936-.878 1.434-.878 1.434-.777.24-.971.752-.971 1.183.004.247.054.49.149.716.038.156.058.316.058.478 0 1.176-1.176 1.534-1.176 1.534-1.049.07-1.23.812-1.23 1.28 0 .119.01.238.032.354l.166.154a.735.735 0 00.391.197h12.94c4.084.014 7.406-3.392 7.42-7.609.007-2.239-.939-4.368-2.586-5.824 3.09-2.755 3.432-7.573.764-10.763C17.722.964 15.68 0 13.53 0h-.006m.447 2.286c2.754 0 4.986 2.305 4.986 5.148 0 2.841-2.23 5.145-4.983 5.147-2.753-.002-4.984-2.305-4.986-5.147h-.004c0-2.843 2.233-5.148 4.987-5.148",
    fill: "url(#".concat(_id6, ")")
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.256 5.44a1.637 1.637 0 11-1.572 1.18.604.604 0 00.74-.95 1.61 1.61 0 01.832-.23z",
    fill: "#1D1D1B"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M30.461 7.921a2.9 2.9 0 013.515 2.112l8.216 32.955a2.9 2.9 0 01-2.111 3.514l-18.487 4.61A2.9 2.9 0 0118.079 49L9.863 16.045a2.9 2.9 0 012.112-3.515zm.685 2.4l-.083.012-18.487 4.609a.414.414 0 00-.302.502l8.217 32.955c.055.221.28.357.502.301l18.486-4.61a.414.414 0 00.302-.501l-8.216-32.955a.414.414 0 00-.502-.301zm-.797 29.643a1.243 1.243 0 01-.79 1.472l-.131.039a1.243 1.243 0 01-.716-2.377l.13-.039c.666-.166 1.34.24 1.507.905z",
    fill: "url(#".concat(_id7, ")"),
    fillRule: "nonzero",
    transform: "rotate(37 24.839 172.948)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#".concat(_id12, ")"),
    transform: "rotate(1 -1646.385 5673.282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.007 2.09c2.386 0 4.32 2.063 4.32 4.609 0 2.544-1.932 4.607-4.318 4.609-2.386-.002-4.32-2.064-4.321-4.61h-.003c0-2.545 1.935-4.609 4.322-4.609",
    fill: "url(#".concat(_id8, ")")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4 0H.491a.51.51 0 00-.314.177L.022.321C.008.401 0 .482 0 .563c0 .956 1.037 1.051 1.037 1.051.597.146 1.008.712.977 1.344 0 .116-.011.231-.035.344-.09.183-.14.384-.142.589 0 .752.819 1.008.819 1.008.445.212.728.673.723 1.178 0 .233-.048.463-.14.676a1.237 1.237 0 00-.272.736c0 .62.633.972.633.972.306.242.488.615.494 1.014a1.7 1.7 0 01-.3.918 1.104 1.104 0 00-.44.845c.028.35.185.673.44.905.192.237.3.535.308.845-.017.42-.197.816-.5 1.099a1.021 1.021 0 00-.619.921c.012.285.107.559.273.786.098.203.15.425.156.65 0 .79-.74 1.21-.74 1.21-.655.202-.819.633-.819.997.003.208.046.412.126.603.032.132.049.267.049.403 0 .991-.99 1.293-.99 1.293C.152 21.009 0 21.634 0 22.029c0 .1.009.2.027.299l.14.13a.62.62 0 00.33.165h10.906c3.443.012 6.243-2.859 6.254-6.413a6.524 6.524 0 00-2.18-4.91c2.605-2.321 2.894-6.383.645-9.071A6.15 6.15 0 0011.405 0H11.4m.377 1.927c2.321 0 4.203 1.943 4.203 4.339 0 2.395-1.88 4.337-4.2 4.339-2.321-.002-4.202-1.944-4.204-4.34h-.002c0-2.395 1.881-4.338 4.203-4.338",
    fill: "url(#".concat(_id9, ")")
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.548 4.806a1.44 1.44 0 11-1.384 1.037.532.532 0 00.65-.836 1.42 1.42 0 01.734-.2z",
    fill: "#1D1D1B"
  })))));
}

export default SvgIconsPopupNotifications;